import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';

import './MergeConfirmModal.scss';

type MergeConfirmModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading: boolean;
};

export const MergeConfirmModal = ({
  isOpen,
  onCancel,
  onConfirm,
  isLoading,
}: MergeConfirmModalProps) => {
  return (
    <Modal
      open={isOpen}
      footer={null}
      closable={false}
      centered
      className="merge-confirm-modal"
      onCancel={onCancel}
    >
      <div className="merge-confirm-modal__content">
        <div className="merge-confirm-modal__header">
          <ExclamationCircleOutlined className="merge-confirm-modal__icon" />
          <p className="merge-confirm-modal__title">
            Do you want to merge your hotel?
          </p>
        </div>
        <div className="merge-confirm-modal__description">
          By merging the child hotel with the parent hotel, you permanently edit
          and delete information.
        </div>
        <div className="merge-confirm-modal__actions">
          <Button onClick={onCancel}>Cancel</Button>
          <Button type="primary" danger onClick={onConfirm} loading={isLoading}>
            Merge
          </Button>
        </div>
      </div>
    </Modal>
  );
};
